import React from "react";
import "./iconStepper.css";

const HorizontalStepper = ({ steps, activeStep, isHorizaontal }) => {
  return (
    <div
      className={`vertical-stepper ${isHorizaontal ? "horizontal" : ""}`}
      role="list"
    >
      {steps.map((step, index) => {
        const Icon = step.icon;
        const isActive = index === activeStep;
        const isCompleted = index < activeStep;
        const isLastStep = index === steps.length - 1;

        return (
          <div
            key={index}
            className="stepper-step"
            role="listitem"
            aria-current={isActive ? "step" : undefined}
          >
            <div className="step-icon-wrapper">
              <div
                className={`step-icon ${
                  isCompleted ? "completed" : isActive ? "active" : ""
                }`}
                aria-label={`Step ${index + 1}: ${step.label}${
                  isCompleted ? " - Completed" : isActive ? " - Current" : ""
                }`}
              >
                {Icon && <Icon size={14} aria-hidden="true" />}
              </div>

              {!isLastStep && (
                <div
                  className={`connector-line ${isCompleted ? "filled" : ""}`}
                  aria-hidden="true"
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HorizontalStepper;
